var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { MemberSearchService, PredicateList } from './member_search.service';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
var MemberSearchConditionListComponent = /** @class */ (function (_super) {
    __extends(MemberSearchConditionListComponent, _super);
    function MemberSearchConditionListComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.condList = [];
        return _this;
    }
    // 初期処理
    MemberSearchConditionListComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        // 検索条件として保存→一覧に表示
        this.subscriptionCondList = this.service.observableCondList.subscribe(function (data) {
            if (typeof data !== 'undefined') {
                var cond = data.cond;
                if (data.mode === 'add') {
                    var searchCond = new DispSearchCondList();
                    searchCond.no = cond.no;
                    searchCond.dispSearchConditionList = cond.disp;
                    _this.condList.push(searchCond);
                }
                else if (data.mode === 'update') {
                    _this.condList[cond.index].dispSearchConditionList = cond.disp;
                }
                else {
                    _this.condList = [];
                    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                        var key = _a[_i];
                        var c = data[key];
                        var searchCond = new DispSearchCondList();
                        searchCond.no = c.no;
                        searchCond.dispSearchConditionList = c.disp;
                        searchCond.enable = c.enable;
                        searchCond.operator = c.operator;
                        _this.condList[c.index] = searchCond;
                    }
                }
                _this.getEnableTopNo();
            }
        });
    };
    MemberSearchConditionListComponent.prototype.setUnsubscribe = function () {
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    MemberSearchConditionListComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.condList = [];
            this.getEnableTopNo();
        }
        else if (e === this.componentName + '#Button#search') {
            this.condListSearch();
        }
    };
    MemberSearchConditionListComponent.prototype.getEnableTopNo = function () {
        this.enableTopNo = 0;
        for (var i = 0; i < this.condList.length; i++) {
            if (this.condList[i].enable === true) {
                this.enableTopNo = this.condList[i].no;
                break;
            }
        }
    };
    // 並び替え
    MemberSearchConditionListComponent.prototype.condListArrows = function (e1, e2, index) {
        if (e2 === 'up') {
            this.service.setCondListParam(this.condList[index].no, 'index', index - 1);
            this.service.setCondListParam(this.condList[index - 1].no, 'index', index);
            this.condList.splice(index - 1, 2, this.condList[index], this.condList[index - 1]);
        }
        else if (e2 === 'down') {
            this.service.setCondListParam(this.condList[index].no, 'index', index + 1);
            this.service.setCondListParam(this.condList[index + 1].no, 'index', index);
            this.condList.splice(index, 2, this.condList[index + 1], this.condList[index]);
        }
        this.getEnableTopNo();
    };
    // And/Or
    MemberSearchConditionListComponent.prototype.condListAndOr = function (e1, index) {
        this.condList[index].operator = e1.target.value;
        this.service.setCondListParam(this.condList[index].no, 'operator', e1.target.value);
    };
    // 編集
    MemberSearchConditionListComponent.prototype.condListEdit = function (e1, index) {
        this.service.setEditCond(this.condList[index].no); // 検索条件設定に条件を反映
    };
    // 有効/無効
    MemberSearchConditionListComponent.prototype.condListEnable = function (e1, e2, index) {
        this.condList[index].enable = e2;
        this.getEnableTopNo();
        this.service.setCondListParam(this.condList[index].no, 'enable', e2);
    };
    // 検索実行
    MemberSearchConditionListComponent.prototype.condListSearch = function () {
        var searchConditionList = [];
        for (var i = 0; i < this.condList.length; i++) {
            if (this.condList[i].enable !== true) {
                continue;
            }
            var searchCond = this.service.getCondList(this.condList[i].no);
            if (this.enableTopNo === this.condList[i].no) {
                searchConditionList.push(Object.assign(new PredicateList(), {
                    predicateList: searchCond.predicateList,
                    no: this.condList[i].no
                }));
            }
            else {
                searchConditionList.push(Object.assign(new PredicateList(), {
                    predicateList: searchCond.predicateList,
                    operator: this.condList[i].operator,
                    no: this.condList[i].no
                }));
            }
        }
        this.logger.debug('searchConditionList:', searchConditionList);
        this.service.setSearchConditionList(searchConditionList);
        var searchVal = this.service.getSearchVal();
        this.service.setSearchVal(searchVal['condition'], searchVal['options'], searchVal['types'], searchVal['operators'], searchVal['toggles'], searchVal['condListNo']);
        this.action.setRec(this.service.getMemberQuery({ searchConditionList: searchConditionList, page: 1 }));
        this.action.firstAction('search');
    };
    MemberSearchConditionListComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    MemberSearchConditionListComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subscriptionCondList.unsubscribe();
    };
    MemberSearchConditionListComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'membersearch-conditionlist',
                    template: "<div class=\"row\" id=\"{{ componentName + '#list' }}\">\n  <div class=\"col-sm-12\">\n    <div class=\"andOrList\">\n      <ng-template [ngIf]=\"condList.length <= 0\">\n        <p class=\"andOrList_description\">{{ (msg | async)['MemberSearchComponent.savedSearchCondition.noSearchCondition'] }}</p>\n      </ng-template>\n      <ng-template ngFor let-cond [ngForOf]=\"condList\" let-index=\"index\">\n        <div *ngIf=\"index > 0\">\n          <select *ngIf=\"cond.enable === true && enableTopNo !== cond.no\" class=\"andOrList_select\" (change)=\"condListAndOr($event, index)\">\n            <option value=\"and\" [selected]=\"cond.operator === 'and'\">--- {{ (msg | async)['MemberSearchComponent.label.operator.and'] }} ---</option>\n            <option value=\"or\" [selected]=\"cond.operator === 'or'\">--- {{ (msg | async)['MemberSearchComponent.label.operator.or'] }} ---</option>\n          </select>\n          <div *ngIf=\"(cond.enable === false || (cond.enable === true && enableTopNo === cond.no))\" class=\"andOrList_invalidWrapper\">\n            <select class=\"andOrList_select\" (change)=\"condListAndOr($event, index)\">\n              <option value=\"and\" [selected]=\"cond.operator === 'and'\">--- {{ (msg | async)['MemberSearchComponent.label.operator.and'] }} ---</option>\n              <option value=\"or\" [selected]=\"cond.operator === 'or'\">--- {{ (msg | async)['MemberSearchComponent.label.operator.or'] }} ---</option>\n            </select>\n          </div>\n        </div>\n        <div>\n          <div class=\"andOrList_boxWrapper\">\n            <ul class=\"andOrList_arrows\">\n              <li *ngIf=\"index > 0\"><a href=\"javascript:void(0);\" class=\"andOrList_arrows_up\" (click)=\"condListArrows($event, 'up', index)\"></a></li>\n              <li *ngIf=\"index < condList.length - 1\"><a href=\"javascript:void(0);\" class=\"andOrList_arrows_down\" (click)=\"condListArrows($event, 'down', index)\"></a></li>\n            </ul>\n\n            <dl *ngIf=\"cond.enable === true\" class=\"andOrList_box\">\n              <dt class=\"andOrList_box_ttl\">{{ (msg | async)['MemberSearchComponent.label.searchCondition'] }} {{ cond.no }}</dt>\n              <dd class=\"andOrList_box_status\">\n                <div *ngFor=\"let cond of cond.dispSearchConditionList; let index = index;\">\n                  <membersearch-conditiongroup [cond]=\"cond\" [index]=\"index\"></membersearch-conditiongroup>\n                </div>\n              </dd>\n            </dl>\n            <div *ngIf=\"cond.enable === false\" class=\"andOrList_invalidWrapper\">\n              <dl class=\"andOrList_box\">\n                <dt class=\"andOrList_box_ttl\">{{ (msg | async)['MemberSearchComponent.label.searchCondition'] }} {{ cond.no }}</dt>\n                <dd class=\"andOrList_box_status\">\n                  <div *ngFor=\"let cond of cond.dispSearchConditionList; let index = index;\">\n                    <membersearch-conditiongroup [cond]=\"cond\" [index]=\"index\"></membersearch-conditiongroup>\n                  </div>\n                </dd>\n              </dl>\n            </div>\n\n            <ul class=\"andOrList_edit\">\n              <li><a href=\"javascript:void(0);\" (click)=\"condListEdit($event, index)\">{{ (msg | async)['MemberSearchComponent.savedSearchCondition.edit'] }}</a></li>\n              <li *ngIf=\"cond.enable === true\"><a href=\"javascript:void(0);\" (click)=\"condListEnable($event, false, index)\">{{ (msg | async)['MemberSearchComponent.savedSearchCondition.disable'] }}</a></li>\n              <li *ngIf=\"cond.enable === false\"><a href=\"javascript:void(0);\" (click)=\"condListEnable($event, true, index)\">{{ (msg | async)['MemberSearchComponent.savedSearchCondition.enable'] }}</a></li>\n            </ul>\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</div>\n<div *ngIf=\"condList.length > 0\" class=\"row -mt-3\" id=\"{{ componentName + '#button' }}\">\n  <div class=\"col-sm-12\">\n    <btn\n        [componentName]=\"componentName + '#SearchButton'\"\n        [component]=\"{\n          params: {\n            mode: 'search',\n            buttons: [{\n              type: 'button',\n              event: componentName + '#Button#search',\n              caption: (msg | async)['MemberSearchComponent.button.searchExecution']\n            }]\n          }\n\t\t}\"></btn>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    MemberSearchConditionListComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: MemberSearchService }
    ]; };
    return MemberSearchConditionListComponent;
}(ContentBaseComponent));
export { MemberSearchConditionListComponent };
var DispSearchCondList = /** @class */ (function () {
    function DispSearchCondList() {
        this.enable = true;
        this.operator = 'and';
    }
    return DispSearchCondList;
}());
export { DispSearchCondList };
//# sourceMappingURL=conditionlist.component.js.map